import * as yup from "yup";

export const CancelOrderSchema = yup.object().shape({
  cancelledReason: yup.string().required("Cancel reason is required"),
});
